import { Box, HStack, Img, Menu, MenuButton, MenuItem, MenuList, Square, Stack, Text, VStack } from '@chakra-ui/react';
import { useContext } from 'react';
import { AuthContext } from '../../../context/authContext';
import { deleteIssue } from '../services/reportIssue';
import { issueTypeStyles } from './issueReportData';
import CautionAlertDialog from '../../../components/CautionAlertDialog';
import { useNavigate } from 'react-router-dom';
import { dynamicPathhandler } from '../../../components/utils/dynamicPathHandler';
import { PROTECTED_PATHS } from '../../../app/constants';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { CgClose } from 'react-icons/cg';

const IssueCard = ({ issue, setRefresh }) => {
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const navigate = useNavigate();
  const { VIEW_REPORT_DETAILS, SEND_MESSAGE_TO_ADMIN } = PROTECTED_PATHS;
  const parentPath = dynamicPathhandler(VIEW_REPORT_DETAILS);
  const messageParent = dynamicPathhandler(SEND_MESSAGE_TO_ADMIN);

  const handleDeleteIssue = (issue) => {
    deleteIssue(userId, issue?._id).then(setRefresh);
  };

  return (
    <HStack justify='space-between' p='2' shadow='sm' gap='10px' my='6' bg='gray.50'>
      <Box width='30%'>
        <Img borderRadius='5px' h='100px' w='100%' objectFit='cover' src={issue.media[0]} alt='issue image' />
      </Box>
      <Stack flex={1}>
        <Square {...issueTypeStyles} fontSize='10px'>
          {issue?.issueType}
        </Square>
        <Text fontSize='15px' fontWeight='500' lineHeight='1'>
          {issue?.title}
        </Text>
        <Text m='2px !important' fontSize='12px'>
          {issue?.description}
        </Text>
      </Stack>
      <VStack w='20px' gap='1.4rem'>
        <CautionAlertDialog
          size='xs'
          cautionTitle={'Are you sure you want to delete this Report?'}
          onContinue={() => handleDeleteIssue(issue)}
          buttonProps={{ bg: 'none', color: 'primary' }}
          button={<CgClose />}
        />

        <Menu>
          <MenuButton as={'p'}>
            <BiDotsVerticalRounded />
          </MenuButton>
          <MenuList>
            <MenuItem onClick={() => navigate(`${parentPath}/${issue._id}`)}>View</MenuItem>
            <MenuItem onClick={() => navigate(`${messageParent}/${issue._id}`)}>Send Message</MenuItem>
          </MenuList>
        </Menu>
      </VStack>
    </HStack>
  );
};

export default IssueCard;
